import setBreakpoint from './setBreakpoint';
import getBreakpoint from './getBreakpoint';

export default { setBreakpoint, getBreakpoint };



// WEBPACK FOOTER //
// ../src/components/core/breakpoints/index.js